import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { ZohoLinkedService } from 'app/model/linkedservice/zoho.linkedservice';
import { Metamodel } from 'app/model/base/model';
import { ZohoObjectDataset } from 'app/model/dataset/zoho.dataset';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const zohoObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(ZohoObjectDataset).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Zoho_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(ZohoLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-zoho'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
